import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD__list_token } from '../../../_fields/_primitives/list/FIELD__list_token';
import { FIELD_PRIMITIVE__int } from '../../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_SD__conditioning_masked } from '../../../_fields/guidance/FIELD_SD__conditioning_masked';
import { FIELD__image_asset } from '../../../_fields/image/FIELD__image_asset';
import { FIELD__ml_asset_clip } from '../../../_fields/ml_asset/FIELD__ml_asset_clip';
import { DTO_GRAPH__edge_autoconnect_info_list } from '../../../_graph/DTO_GRAPH__edge_autoconnect_info_list';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_SD__base } from '../INVOCATION_SD__base';
import { INVOCATION_SD__denoise_latents_pipeline } from '../denoise/INVOCATION_SD__denoise_latents_pipeline';

export class INVOCATION_SD__text_encoder_masked extends INVOCATION_SD__base {
  /*
   * STATIC FIELDS
   */

  static override _class_name_static: string = ENUM__dto_class_name.INVOCATION_SD__TEXT_ENCODER_MASKED;

  /*
   * FIELDS IN
   */

  @FIELD__list_token.init_as_input()
  tokens!: FIELD__list_token;

  @FIELD__ml_asset_clip.init_as_input()
  clip!: FIELD__ml_asset_clip;

  @FIELD__image_asset.init_as_input_transform_stretch({})
  mask_positive!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input({ value: CONSTANTS.COLOR.get_average(0), values_allowed: CONSTANTS.COLOR, value_range: CONSTANTS.COLOR })
  cutoff!: FIELD_PRIMITIVE__int;

  /*
   * FIELDS OUT
   */

  @FIELD_SD__conditioning_masked.init_as_output()
  out__positive!: FIELD_SD__conditioning_masked;

  @FIELD_SD__conditioning_masked.init_as_output()
  out__negative!: FIELD_SD__conditioning_masked;

  /*
   * EVENTS
   */
  edges__try_autocreate(graph: DTO_GRAPH__instance) {
    super.edges__try_autocreate(graph);

    /*
     * INVOCATION_SD__text_encoder ->INVOCATION_SD__denoise_latents_pipeline
     */

    let fields_to_denoise = new DTO_GRAPH__edge_autoconnect_info_list<INVOCATION_SD__denoise_latents_pipeline>();
    fields_to_denoise.invocation_type = INVOCATION_SD__denoise_latents_pipeline;
    fields_to_denoise.add(this.out__positive, ['conditioning_regional__positive']);
    fields_to_denoise.add(this.out__negative, ['conditioning_regional__negative']);

    this.edges__try_autocreate_from_left_to_right(graph, fields_to_denoise);
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__TEXT_ENCODER_MASKED);
  }
}
